"use strict";

var _inherits = require("/root/coin-automate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/root/coin-automate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/root/coin-automate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/root/coin-automate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/coin-automate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Api = exports.HttpClient = exports.ContentType = void 0;

var axios_1 = require("axios");

var ContentType;

(function (ContentType) {
  ContentType["Json"] = "application/json";
  ContentType["FormData"] = "multipart/form-data";
  ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType = exports.ContentType || (exports.ContentType = {}));

var HttpClient = /*#__PURE__*/function () {
  function HttpClient() {
    var _this = this;

    var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, HttpClient);

    var securityWorker = _a.securityWorker,
        secure = _a.secure,
        format = _a.format,
        axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);

    this.securityData = null;

    this.setSecurityData = function (data) {
      _this.securityData = data;
    };

    this.request = function (_b) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var secure, path, type, query, format, body, params, secureParams, requestParams, responseFormat;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                secure = _b.secure, path = _b.path, type = _b.type, query = _b.query, format = _b.format, body = _b.body, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
                _context.t1 = (typeof secure === "boolean" ? secure : this.secure) && this.securityWorker;

                if (!_context.t1) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return this.securityWorker(this.securityData);

              case 5:
                _context.t1 = _context.sent;

              case 6:
                _context.t0 = _context.t1;

                if (_context.t0) {
                  _context.next = 9;
                  break;
                }

                _context.t0 = {};

              case 9:
                secureParams = _context.t0;
                requestParams = this.mergeRequestParams(params, secureParams);
                responseFormat = format && this.format || void 0;

                if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
                  requestParams.headers.common = {
                    Accept: "*/*"
                  };
                  requestParams.headers.post = {};
                  requestParams.headers.put = {};
                  body = this.createFormData(body);
                }

                return _context.abrupt("return", this.instance.request(Object.assign(Object.assign({}, requestParams), {
                  headers: Object.assign(Object.assign({}, type && type !== ContentType.FormData ? {
                    "Content-Type": type
                  } : {}), requestParams.headers || {}),
                  params: query,
                  responseType: responseFormat,
                  data: body,
                  url: path
                })));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), {
      baseURL: axiosConfig.baseURL || ""
    }));
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  _createClass(HttpClient, [{
    key: "mergeRequestParams",
    value: function mergeRequestParams(params1, params2) {
      return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), params2 || {}), {
        headers: Object.assign(Object.assign(Object.assign({}, this.instance.defaults.headers || {}), params1.headers || {}), params2 && params2.headers || {})
      });
    }
  }, {
    key: "createFormData",
    value: function createFormData(input) {
      return Object.keys(input || {}).reduce(function (formData, key) {
        var property = input[key];
        formData.append(key, property instanceof Blob ? property : typeof property === "object" && property !== null ? JSON.stringify(property) : "".concat(property));
        return formData;
      }, new FormData());
    }
  }]);

  return HttpClient;
}();

exports.HttpClient = HttpClient;

var Api = /*#__PURE__*/function (_HttpClient) {
  _inherits(Api, _HttpClient);

  var _super = _createSuper(Api);

  function Api() {
    var _this2;

    _classCallCheck(this, Api);

    _this2 = _super.apply(this, arguments);
    _this2.api = {
      authControllerLogin: function authControllerLogin(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/login",
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      authControllerForgot: function authControllerForgot(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/auth/forgotpassword",
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      authControllerResetPassword: function authControllerResetPassword(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/auth/renewpassword",
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      authControllerChangePassword: function authControllerChangePassword(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/auth/changepassword",
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      authControllerChangePasswordForUser: function authControllerChangePasswordForUser(id, data) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return _this2.request(Object.assign({
          path: "/api/auth/changepassword/".concat(id),
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      authControllerGetMe: function authControllerGetMe() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _this2.request(Object.assign({
          path: "/api/me",
          method: "GET",
          secure: true,
          format: "json"
        }, params));
      },
      usersControllerUploadImage: function usersControllerUploadImage() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _this2.request(Object.assign({
          path: "/api/upload/image",
          method: "POST",
          format: "json"
        }, params));
      },
      usersControllerUploadFile: function usersControllerUploadFile() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _this2.request(Object.assign({
          path: "/api/upload/file",
          method: "POST",
          format: "json"
        }, params));
      },
      permissionsControllerGetAllPermissions: function permissionsControllerGetAllPermissions() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _this2.request(Object.assign({
          path: "/api/permissions",
          method: "GET"
        }, params));
      },
      permissionsControllerGrantPermissions: function permissionsControllerGrantPermissions(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/permissions",
          method: "POST",
          body: data,
          type: ContentType.Json
        }, params));
      },
      permissionsControllerGetPermissionsByUserId: function permissionsControllerGetPermissionsByUserId(userId) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/permissions/".concat(userId),
          method: "GET"
        }, params));
      },
      departmentsControllerGetPermissionsByUserId: function departmentsControllerGetPermissionsByUserId() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _this2.request(Object.assign({
          path: "/api/departments",
          method: "GET",
          format: "json"
        }, params));
      },
      departmentsControllerGrantPermissions: function departmentsControllerGrantPermissions(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/departments",
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      departmentsControllerUpdateDepartment: function departmentsControllerUpdateDepartment(id, data) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return _this2.request(Object.assign({
          path: "/api/departments/".concat(id),
          method: "PATCH",
          body: data,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      departmentsControllerDeleteDepartment: function departmentsControllerDeleteDepartment(id) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/departments/".concat(id),
          method: "DELETE",
          format: "json"
        }, params));
      },
      positionsControllerGetPermissionsByUserId: function positionsControllerGetPermissionsByUserId() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _this2.request(Object.assign({
          path: "/api/positions",
          method: "GET",
          format: "json"
        }, params));
      },
      positionsControllerGrantPermissions: function positionsControllerGrantPermissions(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/positions",
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      positionsControllerUpdatePosition: function positionsControllerUpdatePosition(id, data) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return _this2.request(Object.assign({
          path: "/api/positions/".concat(id),
          method: "PATCH",
          body: data,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      positionsControllerDeletePosition: function positionsControllerDeletePosition(id) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/api/positions/".concat(id),
          method: "DELETE",
          format: "json"
        }, params));
      }
    };
    _this2.crud = {
      deleteOneBaseUserCrudUser: function deleteOneBaseUserCrudUser(id) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/crud/users/".concat(id),
          method: "DELETE",
          secure: true
        }, params));
      },
      getOneBaseUserCrudUser: function getOneBaseUserCrudUser(id, query) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return _this2.request(Object.assign({
          path: "/crud/users/".concat(id),
          method: "GET",
          query: query,
          secure: true,
          format: "json"
        }, params));
      },
      updateOneBaseUserCrudUser: function updateOneBaseUserCrudUser(id, data) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return _this2.request(Object.assign({
          path: "/crud/users/".concat(id),
          method: "PATCH",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      replaceOneBaseUserCrudUser: function replaceOneBaseUserCrudUser(id, data) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return _this2.request(Object.assign({
          path: "/crud/users/".concat(id),
          method: "PUT",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      createManyBaseUserCrudUser: function createManyBaseUserCrudUser(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/crud/users/bulk",
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json"
        }, params));
      },
      getManyBaseUserCrudUser: function getManyBaseUserCrudUser(query) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/crud/users",
          method: "GET",
          query: query,
          secure: true,
          format: "json"
        }, params));
      },
      createOneBaseUserCrudUser: function createOneBaseUserCrudUser(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this2.request(Object.assign({
          path: "/crud/users",
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json"
        }, params));
      }
    };
    return _this2;
  }

  return Api;
}(HttpClient);

exports.Api = Api;